<template>
  <div class="color-new">
    <div class="close"
      @click="$router.push('/user/surface-design-color/' + surfaceDesignColorsStore.selectedCollectionId)">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M5 4.25a.75.75 0 0 0-.531.219.75.75 0 0 0 0 1.062L8.937 10 4.47 14.469a.75.75 0 0 0 0 1.062.75.75 0 0 0 1.062 0L10 11.062l4.469 4.47a.75.75 0 0 0 1.062 0 .75.75 0 0 0 0-1.063L11.062 10l4.47-4.469a.75.75 0 0 0 0-1.062A.75.75 0 0 0 15 4.25a.75.75 0 0 0-.531.219L10 8.937 5.531 4.47A.75.75 0 0 0 5 4.25z"></path></svg>
      Close
    </div>
    <div class="select-colors">
      <div class="select-colors__container">
        <div class="text-block">
          <h3>{{ surfaceDesignColorsStore.selectedCollectionName }}</h3>
        </div>
        <div class="select-color-mode">
          <div class="select-block-radio">
            <div
              :class="`radio-item ${colorMode === 'wheel' ? 'active' : ''}`"
              @click="selectColorMode('wheel')"
            >
              Color wheel
            </div>
            <div
              :class="`radio-item ${colorMode === 'system' ? 'active' : ''}`"
              @click="selectColorMode('system')"
            >
              System presets
            </div>
          </div>
        </div>
        <div v-show="colorMode === 'wheel'">
          <div class="select-mode">
            <p>Color mode</p>
            <div class="select-mode__switcher">
              HEX
              <Switcher v-model="isRgbMode"/>
              RGB
            </div>
          </div>
          <div class="wheel-wrapper" ref="wrapper">
            <canvas ref="satRing" class="sat-ring" :style="canvasStyle(ringSize)" />
            <canvas ref="wheel" class="wheel" :style="canvasStyle(wheelSize)" />
            <div
              v-if="selector.x !== null"
              class="selector"
              :style="{ left: selector.x + 'px', top: selector.y + 'px' }"
            />
            <div
              v-if="selector1.x !== null"
              class="selector"
              :style="{ left: selector1.x + 'px', top: selector1.y + 'px' }"
            />
          </div>
        </div>
        <div v-show="colorMode === 'system'">
          <InputField v-model="search" placeholder="Search" style="margin-top: 16px;">
            <template v-slot:start-icon>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21">
                <path d="M8.334 2.25c-3.627 0-6.584 2.957-6.584 6.584s2.957 6.582 6.584 6.582a6.547 6.547 0 0 0 4.088-1.432l4.547 4.547a.75.75 0 0 0 1.062 0 .75.75 0 0 0 0-1.062l-4.547-4.547a6.547 6.547 0 0 0 1.432-4.088c0-3.627-2.955-6.584-6.582-6.584zm0 1.5a5.071 5.071 0 0 1 5.082 5.084 5.07 5.07 0 0 1-5.082 5.082A5.071 5.071 0 0 1 3.25 8.834 5.073 5.073 0 0 1 8.334 3.75z"/>
              </svg>
            </template>
          </InputField>
          <div class="system-palete">
            <div
              :class="`system-palete__item ${color.selected ? 'selected' : ''}`"
              v-for="(color, index) in filteredDefaultColors" :key="index"
              @click="selectColor(color, index)"
            >
              <div
                class="color"
                :style="`background: ${color.hex}; color: ${isColorLight(color.hex) ? 'var(--Basic-Black)' : 'var(--Basic-White)'};`">{{color.hex}}</div>
              <p>{{color.name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="palette">
    <!-- <div class="palette" :style="`max-height:${colorHeight}px;`"> -->
      <div class="files" :style="`grid-template-columns: repeat(${surfaceDesignColorsStore.collumnCount}, 1fr)`">
        <div class="item"
          v-for="(item, index) in surfaceDesignColorsStore.palette" :key="index"
          @click="selectedIndex = index">
          <div class="tooltiptext" v-if="item.double">There cannot be two identical colors in the palette</div>
          <label
            :class="`import-file ${index === selectedIndex ? 'active' : ''} ${item.rgb ? 'file' : ''} ${item.error || item.double ? 'error' : ''} ${item.id ? 'ok' : ''}`"
            :style="item.hex ? `background-color:${item.hex}` : ''"
          >
            <div v-if="index === selectedIndex && colorMode === 'wheel'" class="input-color">
              <input
                @input="formatHex($event, index)" maxlength="7"
                v-if="!isRgbMode" type="text" :value="item.hex"
                :style="`color: ${isColorLight(item.hex) ? 'var(--Basic-Black)' : 'var(--Basic-White)'};`"
                placeholder="HEX code" />
              <input
                v-model="item.rgb"
                @input="formatRGB($event, index)"
                v-else
                :style="`color: ${isColorLight(item.hex) ? 'var(--Basic-Black)' : 'var(--Basic-White)'};`"
                placeholder="RGB code" />
            </div>
            <p v-else :style="`color: ${isColorLight(item.hex) ? 'var(--Basic-Black)' : 'var(--Basic-White)'};`">{{isRgbMode ? item.rgb : item.hex}}</p>
            <svg v-if="!item.rgb && !item.hex && index !== selectedIndex" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" width="20" height="20">
              <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 10h10m-5 5V5"/>
            </svg>
            <svg class="ok-icon" v-if="item.id" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m6 12 4.2426 4.2426 8.4853-8.48528"/>
            </svg>
            <div class="del-no-ok" v-if="(item.rgb || item.hex) && !item.id" @click="surfaceDesignColorsStore.delColor(index)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 5H5v11.6667c0 .4602.3731.8333.83333.8333h8.33337c.4602 0 .8333-.3731.8333-.8333V5ZM3.33398 5H16.6673m-4.168-2.5H7.49935c-.46024 0-.83333.3731-.83333.83333V5h6.66668V3.33333c0-.46023-.3731-.83333-.8334-.83333Z"/>
              </svg>
            </div>
            <div class="del" v-if="(item.rgb || item.hex) && item.id" @click="surfaceDesignColorsStore.delColor(index)">
              <svg width="20"  height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 5H5v11.6667c0 .4602.3731.8333.83333.8333h8.33337c.4602 0 .8333-.3731.8333-.8333V5ZM3.33398 5H16.6673m-4.168-2.5H7.49935c-.46024 0-.83333.3731-.83333.83333V5h6.66668V3.33333c0-.46023-.3731-.83333-.8334-.83333Z"/>
              </svg>
            </div>
          </label>
          <input :class="item.rgb || item.hex ? 'input-name red' : 'input-name'" v-model="item.name" placeholder="Name">
          <p class="error" v-if="item.error">{{item.error}}</p>
        </div>
      </div>
    </div>
    <div class="bottom-panel">
      <ButtonPrimary class="small" :disabled="!surfaceDesignColorsStore.canSave"
        @click.native="surfaceDesignColorsStore.savePallete($router)">
        Save palette
      </ButtonPrimary>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useSurfaceDesignColorsStore } from '@/store/pinia/surfaceDesignColors'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import Switcher from '@/components/Atoms/Switcher'
import InputField from '@/components/Atoms/InputField'

export default {
  name: 'ColorWheelPicker',
  components: {
    ButtonPrimary,
    Switcher,
    InputField,
  },
  data () {
    return {
      isRgbMode: false,
      colorMode: 'wheel',
      hue: 0,
      saturation: 1,
      value: 1,
      palette: [],
      selector: { x: null, y: null },
      selector1: { x: null, y: null },
      wheelSize: 260,
      ringSize: 300,
      ringThickness: 20,
      ringGap: 6,
      selectedIndex: 0,
      colorHeight: 320,
      defaultColors: [],
      search: null,
    }
  },
  async mounted () {
    const req = await fetch('/colors.json')
    const res = await req.json()
    this.defaultColors = res.map(el => {
      return {
        name: el.Name,
        hex: `#${el.HEX}`,
        rgb: el.sRGB,
        selected: false,
      }
    })
    this.surfaceDesignColorsStore.palette = []
    this.handleResize()
    this.surfaceDesignColorsStore.makeImgArray()
    window.addEventListener('resize', this.handleResize)
    try {
      const saved = JSON.parse(localStorage.getItem('palette-autumn') || '[]')
      if (Array.isArray(saved)) this.palette = saved
    } catch (e) { console.log(e) }
    this.drawHueWheel()
    this.drawSaturationRing()
    this.$refs.wheel.addEventListener('pointerdown', this.onWheelPointerDown)
    this.$refs.satRing.addEventListener('pointerdown', this.onRingPointerDown)
  },
  beforeUnmount () {
    document.removeEventListener('pointermove', this.onGlobalPointerMove)
    document.removeEventListener('pointerup', this.onGlobalPointerUp)
  },
  computed: {
    filteredDefaultColors () {
      if (this.search) {
        return this.defaultColors.filter(el => {
          return el.name.toLowerCase().includes(this.search.toLowerCase()) || el.hex.toLowerCase().includes(this.search.toLowerCase()) || el.rgb.toLowerCase().includes(this.search.toLowerCase())
        })
      } else return this.defaultColors
    },
    ...mapStores(useSurfaceDesignColorsStore),
    rgbObj () {
      const { r, g, b } = this.hsvToRgb(this.hue, this.saturation, this.value)
      return { r, g, b }
    },
    rgb () {
      const { r, g, b } = this.rgbObj
      return `rgb(${r}, ${b !== undefined ? g : g}, ${b})`
    },
    hex () {
      const { r, g, b } = this.rgbObj
      return this.rgbToHex(r, g, b)
    },
  },
  methods: {
    selectColor (color, index) {
      if (!color.selected) {
        this.surfaceDesignColorsStore.palette.push({
          ...color,
          isSystem: true,
          index: index,
          double: this.surfaceDesignColorsStore.palette.find((el) => el.hex === color.hex),
        })
        this.defaultColors[index].selected = true
      }
    },
    selectColorMode (type) {
      if (type === 'wheel') {
        this.surfaceDesignColorsStore.makeImgArray()
      } else {
        this.surfaceDesignColorsStore.makeFullImgArray()
        if (this.surfaceDesignColorsStore.palette.length) {
          this.surfaceDesignColorsStore.palette.forEach(el => {
            if (el.isSystem && this.defaultColors[el.index].hex !== el.hex) {
              this.defaultColors[el.index].selected = false
            }
          })
        }
        this.isRgbMode = false
      }
      this.colorMode = type
    },
    formatRGB (event, index) {
      let value = event.target.value
      value = value.replace(/[^\d, ]/g, '')
      this.surfaceDesignColorsStore.palette[index].rgb = value
      const parts = value.split(',').map(part => part.trim())
      const validated = parts.map(part => {
        if (part === '') return part
        let num = parseInt(part)
        if (num > 255) num = 255
        return num.toString()
      })
      if (validated.some((val, i) => val === '255' && parts[i] !== '255')) {
        this.surfaceDesignColorsStore.palette[index].rgb = validated.join(', ')
      }
      if (validated.length === 3 && validated.every(part => part !== '')) {
        const r = Number(validated[0])
        const g = Number(validated[1])
        const b = Number(validated[2])
        let hex = this.rgbToHex(r, g, b)
        this.surfaceDesignColorsStore.palette[index].double = this.surfaceDesignColorsStore.palette.find(el => el.hex?.toUpperCase() === hex.toUpperCase())
        this.surfaceDesignColorsStore.palette[index].hex = hex
        this.surfaceDesignColorsStore.makeImgArray()
      } else {
        this.surfaceDesignColorsStore.palette[index].hex = ''
        this.surfaceDesignColorsStore.palette[index].double = null
      }
    },
    isColorLight (hex) {
      const { r, g, b } = this.hexToRgb(hex)
      const brightness = (r * 299 + g * 587 + b * 114) / 1000
      return brightness > 128
    },
    formatHex (e, index) {
      let value = e.target.value.toUpperCase()
      value = value.replace(/[^#A-Z0-9]/g, '')
      if (value.length > 0 && value[0] !== '#') {
        value = '#' + value.replace(/#/g, '')
      }
      if (value.length > 1) {
        value = '#' + value.substring(1).replace(/#/g, '')
      }
      value = value.substring(0, 7)
      if (this.surfaceDesignColorsStore.palette[index].hex !== value) {
        this.surfaceDesignColorsStore.palette[index].double = this.surfaceDesignColorsStore.palette.find(el => el.hex?.toUpperCase() === value.toUpperCase())
        const { r, g, b } = this.hexToRgb(value)
        this.surfaceDesignColorsStore.palette[index].rgb = `${r}, ${g}, ${b}`
        this.surfaceDesignColorsStore.palette[index].hex = value
        this.surfaceDesignColorsStore.makeImgArray()
      }
    },
    handleResize () {
      const pageSize = window.innerWidth
      this.surfaceDesignColorsStore.collumnCount =
        pageSize > 1200 ? 5 : pageSize < 1200 && pageSize > 768 ? Math.floor((pageSize / 2 - 32) / 119) : Math.floor((pageSize - 32) / 119)
      const pageHeight = window.innerHeight
      const colorSize = Math.floor(pageHeight - 60 - 400)
      this.colorHeight = colorSize < 320 ? 320 : colorSize
    },
    setupCanvas (canvas, logicalSize) {
      const dpr = Math.max(1, window.devicePixelRatio || 1)
      canvas.width = Math.floor(logicalSize * dpr)
      canvas.height = Math.floor(logicalSize * dpr)
      canvas.style.width = logicalSize + 'px'
      canvas.style.height = logicalSize + 'px'
      const ctx = canvas.getContext('2d')
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
      return ctx
    },
    canvasStyle (size) {
      return {
        width: size + 'px',
        height: size + 'px',
      }
    },
    drawHueWheel () {
      const canvas = this.$refs.wheel
      const ctx = this.setupCanvas(canvas, this.wheelSize)
      const dpr = Math.max(1, window.devicePixelRatio || 1)
      const physicalSize = Math.floor(this.wheelSize * dpr)
      const R = physicalSize / 2
      const img = ctx.createImageData(physicalSize, physicalSize)
      for (let y = 0; y < physicalSize; y++) {
        for (let x = 0; x < physicalSize; x++) {
          const dx = x - R
          const dy = y - R
          const dist = Math.sqrt(dx * dx + dy * dy)
          const base = (y * physicalSize + x) * 4
          if (dist <= R) {
            const angle = Math.atan2(dy, dx)
            const hueDeg = (angle * 180 / Math.PI + 360) % 360
            const { r, g, b } = this.hsvToRgb(hueDeg, 1, 1)
            img.data[base] = r
            img.data[base + 1] = g
            img.data[base + 2] = b
            img.data[base + 3] = 255
          } else {
            img.data[base + 3] = 0
          }
        }
      }
      ctx.setTransform(1, 0, 0, 1, 0, 0)
      ctx.putImageData(img, 0, 0)
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
    },
    drawSaturationRing () {
      const canvas = this.$refs.satRing
      const ctx = this.setupCanvas(canvas, this.ringSize)
      const R = this.ringSize / 2
      const innerR = this.wheelSize / 2 + this.ringGap
      const outerR = innerR + this.ringThickness
      ctx.clearRect(0, 0, this.ringSize, this.ringSize)
      ctx.lineCap = 'butt'
      ctx.lineWidth = outerR - innerR
      for (let i = 0; i < 360; i++) {
        const start = (i - 1) * Math.PI / 180
        const end = i * Math.PI / 180
        const mid = (start + end) / 2
        const verticalPos = Math.sin(mid)
        let sat, val
        if (verticalPos < 0) {
          sat = 1
          val = 1 + verticalPos
        } else {
          sat = 1 - verticalPos
          val = 1
        }
        const { r, g, b } = this.hsvToRgb(this.hue, sat, val)
        ctx.beginPath()
        ctx.strokeStyle = `rgb(${r}, ${g}, ${b})`
        ctx.arc(R, R, (innerR + outerR) / 2, start, end)
        ctx.stroke()
      }
      ctx.globalCompositeOperation = 'destination-out'
      ctx.beginPath()
      ctx.arc(R, R, innerR - 0.5, 0, Math.PI * 2)
      ctx.fill()
      ctx.globalCompositeOperation = 'source-over'
    },
    onWheelPointerDown (e) {
      this.pickHueFromEvent(e)
      this.dragMode = 'wheel'
      document.addEventListener('pointermove', this.onGlobalPointerMove)
      document.addEventListener('pointerup', this.onGlobalPointerUp)
    },
    onRingPointerDown: function (e) {
      this.pickSaturationFromEvent(e)
      this.dragMode = 'ring'
      document.addEventListener('pointermove', this.onGlobalPointerMove)
      document.addEventListener('pointerup', this.onGlobalPointerUp)
    },
    onGlobalPointerMove (e) {
      if (this.dragMode === 'wheel') this.pickHueFromEvent(e)
      else if (this.dragMode === 'ring') this.pickSaturationFromEvent(e)
    },
    onGlobalPointerUp () {
      this.dragMode = null
      document.removeEventListener('pointermove', this.onGlobalPointerMove)
      document.removeEventListener('pointerup', this.onGlobalPointerUp)
    },
    pickHueFromEvent (e) {
      const wheelRect = this.$refs.wheel.getBoundingClientRect()
      const wrapRect = this.$refs.wrapper.getBoundingClientRect()
      const xInWheel = e.clientX - wheelRect.left
      const yInWheel = e.clientY - wheelRect.top
      const cx = wheelRect.width / 2
      const cy = wheelRect.height / 2
      const dx = xInWheel - cx
      const dy = yInWheel - cy
      const R = this.wheelSize / 2
      const dist = Math.hypot(dx, dy)
      if (dist > R) return
      const angle = Math.atan2(dy, dx)
      const hue = (angle * 180 / Math.PI + 360) % 360
      this.hue = hue
      const x = e.clientX - wrapRect.left
      const y = e.clientY - wrapRect.top
      this.selector = { x, y }
      this.surfaceDesignColorsStore.palette[this.selectedIndex].double = this.surfaceDesignColorsStore.palette.find((el, index) => el.hex?.toUpperCase() === this.hex?.toUpperCase() && index !== this.selectedIndex)
      this.surfaceDesignColorsStore.palette[this.selectedIndex].hex = this.hex
      const { r, g, b } = this.hexToRgb(this.hex)
      this.surfaceDesignColorsStore.palette[this.selectedIndex].rgb = `${r}, ${g}, ${b}`
      this.surfaceDesignColorsStore.makeImgArray()
      this.drawSaturationRing()
    },
    pickSaturationFromEvent (e) {
      const rect = this.$refs.satRing.getBoundingClientRect()
      const wrapRect = this.$refs.wrapper.getBoundingClientRect()
      const cx = rect.width / 2
      const cy = rect.height / 2
      const x = e.clientX - rect.left - cx
      const y = e.clientY - rect.top - cy
      const angle = Math.atan2(y, x)
      const verticalPos = Math.sin(angle)
      if (verticalPos < 0) {
        this.saturation = 1
        this.value = 1 + verticalPos
      } else {
        this.saturation = 1 - verticalPos
        this.value = 1
      }
      this.saturation = Math.max(0, Math.min(1, this.saturation))
      this.value = Math.max(0, Math.min(1, this.value))
      const innerR = this.wheelSize / 2 + this.ringGap
      const outerR = innerR + this.ringThickness
      const middleRadius = (innerR + outerR) / 2
      const selectorX = Math.cos(angle) * middleRadius + cx
      const selectorY = Math.sin(angle) * middleRadius + cy
      const offsetX = rect.left - wrapRect.left
      const offsetY = rect.top - wrapRect.top
      this.selector1 = {
        x: selectorX + offsetX,
        y: selectorY + offsetY,
      }
      this.surfaceDesignColorsStore.palette[this.selectedIndex].double = this.surfaceDesignColorsStore.palette.find((el, index) => el.hex?.toUpperCase() === this.hex?.toUpperCase() && index !== this.selectedIndex)
      this.surfaceDesignColorsStore.palette[this.selectedIndex].hex = this.hex
      const { r, g, b } = this.hexToRgb(this.hex)
      this.surfaceDesignColorsStore.palette[this.selectedIndex].rgb = `${r}, ${g}, ${b}`
      this.surfaceDesignColorsStore.makeImgArray()
    },
    hsvToRgb (h, s, v) {
      const c = v * s
      const x = c * (1 - Math.abs(((h / 60) % 2) - 1))
      const m = v - c
      let r, g, b
      if (h < 60) [r, g, b] = [c, x, 0]
      else if (h < 120) [r, g, b] = [x, c, 0]
      else if (h < 180) [r, g, b] = [0, c, x]
      else if (h < 240) [r, g, b] = [0, x, c]
      else if (h < 300) [r, g, b] = [x, 0, c]
      else [r, g, b] = [c, 0, x]
      return {
        r: Math.round((r + m) * 255),
        g: Math.round((g + m) * 255),
        b: Math.round((b + m) * 255),
      }
    },
    rgbToHex (r, g, b) {
      return '#' + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('')
    },
    setFromHex (hex) {
      const { r, g, b } = this.hexToRgb(hex)
      const { h, s, v } = this.rgbToHsv(r, g, b)
      this.hue = h; this.saturation = s; this.value = v
      this.drawSaturationRing()

      const angle = (h * Math.PI) / 180
      const R = this.wheelSize / 2 - 1
      const wrapRect = this.$refs.wrapper.getBoundingClientRect()
      const centerX = wrapRect.width / 2
      const centerY = wrapRect.height / 2
      const x = centerX + Math.cos(angle) * R
      const y = centerY + Math.sin(angle) * R
      this.selector = { x, y }
    },
    hexToRgb (hex) {
      const m = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(hex)
      if (!m) return { r: 255, g: 255, b: 255 }
      return { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) }
    },
    rgbToHsv (r, g, b) {
      r /= 255; g /= 255; b /= 255
      const max = Math.max(r, g, b)
      const min = Math.min(r, g, b)
      const d = max - min
      let h
      if (d === 0) h = 0
      else if (max === r) h = 60 * (((g - b) / d) % 6)
      else if (max === g) h = 60 * ((b - r) / d + 2)
      else h = 60 * ((r - g) / d + 4)
      if (h < 0) h += 360
      const s = max === 0 ? 0 : d / max
      const v = max
      return { h, s, v }
    },
  },
}
</script>

<style lang="scss">
.color-new {
  background: var(--Background);
  position: fixed;
  left: 0;
  top: 60px;
  width: 100%;
  height: calc(100% - 60px);
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  color: var(--Text-Text_Secondary);
  overflow: scroll;
  display: flex;
  .system-palete {
    display: flex;
    gap: 19px;
    margin-top: 24px;
    flex-wrap: wrap;
    &__item.selected {
      cursor: default;
      .color {
        border-color: var(--Button-States-Pressed);
      }
    }
    &__item {
      max-width: 95px;
      cursor: pointer;
      .color {
        height: 96px;
        width: 95px;
        border-radius: 8px;
        border: 1px solid var(--Dividers);
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 600;
      }
      p {
        font-size: 14px;
        color: var(--Text-Text_Primary);
      }
    }
  }
  .select-colors {
    padding: 0 16px;
    width: 50%;
    max-height: calc(100% - 73px);
    overflow: scroll;
    &__container {
      max-width: 440px;
      margin: auto;
    }
  }
  p {
    margin: 0;
  }
  h3 {
    color: var(--Text-Text_Primary);
    text-align: center;
    font-family: Unbounded;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    margin: 16px 0 8px;
  }
  .close {
    position: absolute;
    top: 24px;
    left: 16px;
    display: flex;
    align-items: center;
    gap: 4px;
    color: var(--Primary-Shades-Primary);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    cursor: pointer;
  }
  .text-block {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .bottom-panel {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid var(--Dividers);
    padding: 16px;
    display: flex;
    justify-content: center;
    background: var(--Background);
  }
  .select-color-mode {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 16px;
    .select-block-radio {
      width: 100%;
    }
    .radio-item {
      font-weight: 600;
      width: 50%;
    }
  }
  .select-mode {
    display: flex;
    gap: 16px;
    justify-content: space-between;
    margin-top: 24px;
    p {
      color: var(--Text-Text_Secondary);
      font-size: 14px;
    }
    &__switcher {
      display: flex;
      gap: 12px;
      color: var(--Text-Text_Primary);
    }
  }
  .files {
    display: grid;
    gap: 24px;
    max-width: 1055px;
    margin: 40px auto 113px;
    height: fit-content;
    .tooltiptext {
      max-width: 190px;
      bottom: calc(100% + 13px);
      background-color: #09373D;
      color: #fff;
      text-align: center;
      border-radius: 6px;
      padding: 4px 12px;
      font-size: 12px;
      line-height: normal;
      position: absolute;
      z-index: 1;
      transform: translateX(-50%);
      width: max-content;
      left: 50%;
      transition: opacity 0.3s;
      &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #09373D transparent transparent transparent;
      }
    }
    .item {
      width: 95px;
      position: relative;
      .error {
        font-size: 14px;
        color: var(--System-Error);
        line-height: 16px;
        text-align: center;
      }
      .import-file.active {
        border: 1px solid var(--Primary-Button-Surface);
      }
      .import-file.file {
        border: 1px solid var(--Primary-Button-Surface);
      }
      .import-file.error {
        border: 1px solid var(--System-Error);
      }
      .import-file.ok {
        img { opacity: 0.8; }
        .ok-icon {
          position: absolute;
        }
      }
      .import-file {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 95px;
        position: relative;
        border-radius: 8px;
        border: 1px solid var(--Dividers);
        margin-bottom: 8px;
        cursor: pointer;
        p {
          font-weight: 600;
          font-size: 13px;
        }
        .input-color {
          input {
            color: var(--Basic-Black);
            border: none;
            padding: 13px;
            background: none;
            width: 100%;
            font-size: 13px;
            &::placeholder {
              color: var(--Text-Text_Tertairty);
            }
          }
        }
        .del {
          position: absolute;
          height: 40px;
          width: 40px;
          padding: 10px;
          border-radius: 8px;
          background: var(--primary);
          opacity: 0;
          cursor: pointer;
          margin-top: 75px;
        }
        &:hover {
          .del, .del-no-ok {
            opacity: 1;
          }
        }
        .del-no-ok {
          border: 1px solid var(--Secondary-Button-Stroke);
          position: absolute;
          height: 24px;
          width: 24px;
          padding: 2px;
          border-radius: 4px;
          background: var(--Basic-White);
          opacity: 0;
          cursor: pointer;
          top: -12px;
          right: -12px;
        }
        .edit {
          width: 100%;
          height: 100%;
          position: absolute;
          .input-container {
            position: relative;
            width: 100%;
            height: 100%;
          }
        }
        .edit-file {
          cursor: pointer;
          width: 24px;
          height: 24px;
          padding: 1px;
          position: absolute;
          border-radius: 4px;
          border: 1px solid var(--Secondary-Button-Stroke);
          background: var(--Basic-White);
          top: -10px;
          right: -10px;
          .input-container {
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        input[type="file"] {
          position: absolute;
          width: 100%;
          height: 100%;
          font-size: 0;
          background-color: rgba(0,0,0,0);
          cursor: pointer;
          z-index: 100;
          top: 0;
          left: 0;
          &::file-selector-button {
            display: none;
          }
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
        }
      }
      input:focus-visible {
        outline: none;
      }
      input::placeholder {
        color: var(--Primary-Button-Surface);
      }
      .input-name.red {
        &::placeholder {
          color: var(--Active-State-Strokes);
        }
      }
      .input-name {
        width: 100%;
        border: none;
        color: var(--Primary-Button-Surface);
        font-size: 14px;
        text-align: center;
        background: inherit;
        &::placeholder {
          color: var(--Text-Text_Tertairty);
        }
      }
    }
  }
  .wheel-wrapper {
    position: relative;
    margin: 170px auto;
    display: grid;
    place-items: center;
  }
  .wheel, .sat-ring {
    position: absolute;
    inset: 0;
    margin: auto;
    border-radius: 50%;
    touch-action: none;
    cursor: crosshair;
    }
  .sat-ring { z-index: 0 }
  .wheel {
    width: 260px;
    height: 260px;
    z-index: 1
  }
  .selector {
    position: absolute;
    width: 12px;
    height: 12px;
    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: 0 0 3px rgba(0,0,0,.6);
    transform: translate(-6px, -6px);
    pointer-events: none;
    z-index: 2
  }
  .palette {
    display: grid;
    gap: 10px;
    justify-items: center;
    overflow: scroll;
    width: 50%;
    border-left: 1px solid var(--Dividers, #E0E9EA);
    background: var(--Surface, #FAFBFB);
    padding: 0 16px;
  }
}
@media (max-width: 1150px) {
  .color-new .files {
    margin: 86px auto 128px;
    .tooltiptext {
      max-width: 120px;
    }
  }
}
@media (max-width: 768px) {
  .color-new {
    flex-direction: column;
    .text-block {
      margin-top: 16px;
    }
    .close {
      z-index: 1;
    }
    .palette {
      order: -1;
      width: 100%;
      max-height: 210px;
    }
    .files {
      margin: 60px auto 60px;
    }
    .select-colors {
      width: 100%;
    }
  }
}
</style>
